import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=787b2e46&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=ts"
export * from "./LayoutContent.vue?vue&type=script&lang=ts"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=787b2e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b2e46",
  null
  
)

export default component.exports